var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.625 1.375a.625.625 0 1 0-1.25 0v5h-5a.625.625 0 1 0 0 1.25h5v5a.625.625 0 1 0 1.25 0v-5h5a.625.625 0 1 0 0-1.25h-5z"
})));
export { SvgAddIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/addIcon.svg";